import { useEffect } from 'react';

import { initializeControls } from '@atlassian/browser-storage-controls';

export const InitializeWebStorageControls = () => {
  useEffect(() => {
    initializeControls({
      product: 'Bitbucket',
      webStorageEnabled: true,
    });
  }, []);

  return null;
};
